import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Search, Calculator, BarChart3, Star, Home as HomeIcon } from "lucide-react";
import useSeo from "../../hooks/useSeo";

export default function NotFound() {
    const { t } = useTranslation();
    const [q, setQ] = useState("");
    const nav = useNavigate();
    useSeo({ title: t("404.title"), description: t("404.subtitle"), path: "/404" });

    return (
        <section className="min-h-[70vh] bg-light-bg flex items-center" data-testid="not-found-page">
            <div className="max-w-3xl mx-auto px-6 py-24 text-center">
                <div className="font-data text-7xl sm:text-8xl font-extrabold text-dark-navy/15 tracking-tighter">
                    404
                </div>
                <h1 className="-mt-2 text-3xl sm:text-4xl font-bold text-dark-navy">
                    {t("404.title")}
                </h1>
                <p className="mt-3 text-deep-blue/80">{t("404.subtitle")}</p>

                <form
                    className="mt-8 flex items-stretch max-w-xl mx-auto rounded-lg overflow-hidden border border-slate-300 bg-white shadow-sm"
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (q.trim()) nav(`/blog?q=${encodeURIComponent(q.trim())}`);
                    }}
                >
                    <span className="px-3 inline-flex items-center text-slate-400">
                        <Search className="w-4 h-4" />
                    </span>
                    <input
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        placeholder={t("actions.search")}
                        className="flex-1 px-2 py-3 text-sm outline-none"
                        data-testid="notfound-search-input"
                    />
                    <button className="bg-dark-navy hover:bg-deep-blue text-white px-5 text-sm font-semibold">
                        {t("actions.search")}
                    </button>
                </form>

                <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3">
                    {[
                        { to: "/", icon: HomeIcon, label: t("404.back_home") },
                        { to: "/veri-merkezi", icon: BarChart3, label: t("nav.data") },
                        { to: "/araclar/maliyet-hesaplayici", icon: Calculator, label: t("tools.cost") },
                        { to: "/yildiz-standartlari", icon: Star, label: t("nav.stars") },
                    ].map((it) => {
                        const Icon = it.icon;
                        return (
                            <Link
                                key={it.to}
                                to={it.to}
                                className="lift-card flex flex-col items-center justify-center gap-2 bg-white border border-slate-200 rounded-lg p-4 text-sm text-dark-navy hover:border-teal/40 shadow-md hover:shadow-xl"
                                data-testid={`notfound-link-${it.to}`}
                            >
                                <Icon className="w-5 h-5 text-teal-700" />
                                <span className="font-semibold">{it.label}</span>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
